
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: 605197351a3c8bdd595af2d2a9bc3025bca48ea2
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "605197351a3c8bdd595af2d2a9bc3025bca48ea2"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.OrderScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sharetribeBuyerId: 'sharetribeBuyerId',
  id: 'id',
  shippingAddressId: 'shippingAddressId',
  billingAddressId: 'billingAddressId',
  shopName: 'shopName',
  stripePaymentIntentId: 'stripePaymentIntentId',
  buyerId: 'buyerId',
  shopId: 'shopId',
  paymentMethod: 'paymentMethod'
};

exports.Prisma.AddressScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  state: 'state',
  country: 'country',
  zip: 'zip',
  fullName: 'fullName',
  phone: 'phone',
  id: 'id',
  userId: 'userId'
};

exports.Prisma.BundleItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  bundleId: 'bundleId',
  listingId: 'listingId',
  payoutId: 'payoutId',
  cancellationId: 'cancellationId',
  payoutInfo: 'payoutInfo'
};

exports.Prisma.BundleScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sharetribeSellerId: 'sharetribeSellerId',
  sharetribeTransactionIds: 'sharetribeTransactionIds',
  status: 'status',
  id: 'id',
  orderId: 'orderId',
  isMarkedFulfilled: 'isMarkedFulfilled',
  type: 'type',
  totalPrice: 'totalPrice',
  totalRefundPrice: 'totalRefundPrice',
  canceledAt: 'canceledAt',
  expireAt: 'expireAt',
  sellerId: 'sellerId',
  shipFromAddressId: 'shipFromAddressId',
  shopId: 'shopId',
  verifyAt: 'verifyAt',
  currency: 'currency',
  payoutOption: 'payoutOption',
  completedAt: 'completedAt',
  shopifyOrderId: 'shopifyOrderId',
  isBrandDirect: 'isBrandDirect',
  displayId: 'displayId',
  bdReturnShippingSplitPercentage: 'bdReturnShippingSplitPercentage',
  brandDirectTakeRatePercentage: 'brandDirectTakeRatePercentage',
  cashTakeRatePercentage: 'cashTakeRatePercentage',
  ccFeeSplitPercentage: 'ccFeeSplitPercentage',
  creditTakeRatePercentage: 'creditTakeRatePercentage',
  p2pReturnShippingSplitPercentage: 'p2pReturnShippingSplitPercentage',
  brandCoveredShippingTotal: 'brandCoveredShippingTotal',
  isReturnable: 'isReturnable'
};

exports.Prisma.BundleNoteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  authorEmail: 'authorEmail',
  note: 'note',
  bundleId: 'bundleId'
};

exports.Prisma.FulfillmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isBrandFulfilled: 'isBrandFulfilled',
  trackingURL: 'trackingURL',
  trackingNumber: 'trackingNumber',
  labelURL: 'labelURL',
  shippoObjectId: 'shippoObjectId',
  createdByUserId: 'createdByUserId',
  bundleId: 'bundleId',
  returnBundleId: 'returnBundleId',
  weight: 'weight',
  method: 'method',
  shippingLabelProvider: 'shippingLabelProvider',
  status: 'status',
  weightUnit: 'weightUnit',
  labelCost: 'labelCost',
  labelCurrency: 'labelCurrency',
  deliveredAt: 'deliveredAt'
};

exports.Prisma.LineItemScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  code: 'code',
  includeFor: 'includeFor',
  id: 'id',
  orderId: 'orderId',
  bundleId: 'bundleId',
  refundId: 'refundId'
};

exports.Prisma.ListingLineItemScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  price: 'price',
  quantity: 'quantity',
  sharetribeListingId: 'sharetribeListingId',
  id: 'id',
  lineItemId: 'lineItemId',
  listingId: 'listingId',
  currency: 'currency'
};

exports.Prisma.ShippingLineItemScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  price: 'price',
  quantity: 'quantity',
  id: 'id',
  lineItemId: 'lineItemId',
  currency: 'currency'
};

exports.Prisma.TaxLineItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  currency: 'currency',
  value: 'value',
  rate: 'rate',
  metadata: 'metadata',
  lineItemId: 'lineItemId',
  listingLineItemId: 'listingLineItemId',
  taxCode: 'taxCode',
  taxId: 'taxId',
  shippingLineItemId: 'shippingLineItemId'
};

exports.Prisma.DiscountLineItemScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  value: 'value',
  valueType: 'valueType',
  target: 'target',
  metadata: 'metadata',
  id: 'id',
  lineItemId: 'lineItemId',
  currency: 'currency'
};

exports.Prisma.ReturnInsuranceLineItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  currency: 'currency',
  price: 'price',
  provider: 'provider',
  providerId: 'providerId',
  lineItemId: 'lineItemId'
};

exports.Prisma.RefundScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  price: 'price',
  type: 'type',
  note: 'note',
  bundleId: 'bundleId',
  currency: 'currency'
};

exports.Prisma.DisputeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  reason: 'reason',
  note: 'note',
  bundleId: 'bundleId',
  bundleItemId: 'bundleItemId',
  expireAt: 'expireAt'
};

exports.Prisma.DisputeResolutionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  disputeId: 'disputeId',
  shouldReturn: 'shouldReturn',
  shouldPayout: 'shouldPayout',
  isFullRefund: 'isFullRefund',
  refundAmount: 'refundAmount',
  payoutAmount: 'payoutAmount',
  reason: 'reason'
};

exports.Prisma.PayoutScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  price: 'price',
  bundleId: 'bundleId',
  currency: 'currency',
  stripeTransferId: 'stripeTransferId'
};

exports.Prisma.CancellationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  reason: 'reason',
  initiatedBy: 'initiatedBy',
  note: 'note',
  bundleId: 'bundleId'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sharetribeUserId: 'sharetribeUserId',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  createdFromShopId: 'createdFromShopId',
  stripeAccountId: 'stripeAccountId',
  deletedAt: 'deletedAt',
  shippoAccountId: 'shippoAccountId',
  shipFromCountry: 'shipFromCountry',
  preferredLocale: 'preferredLocale',
  isBrand: 'isBrand'
};

exports.Prisma.ListingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sharetribeListingId: 'sharetribeListingId',
  title: 'title',
  price: 'price',
  externalSku: 'externalSku',
  sellerId: 'sellerId',
  shopId: 'shopId',
  availableInventory: 'availableInventory',
  state: 'state',
  currency: 'currency',
  shipFromCountry: 'shipFromCountry',
  findItemMethod: 'findItemMethod',
  itemBrand: 'itemBrand',
  sourceListingId: 'sourceListingId',
  isBrandDirect: 'isBrandDirect',
  itemType: 'itemType',
  sharetribePublicData: 'sharetribePublicData',
  deletedAt: 'deletedAt',
  categories: 'categories',
  creditBoostPromoId: 'creditBoostPromoId',
  internalNotes: 'internalNotes',
  privateSellerNotes: 'privateSellerNotes',
  condition: 'condition',
  notes: 'notes',
  originalPrice: 'originalPrice',
  payoutInfo: 'payoutInfo',
  productHtml: 'productHtml',
  quirks: 'quirks',
  selectedVariantOptions: 'selectedVariantOptions',
  tags: 'tags',
  promosActive: 'promosActive',
  syncShopifyInventory: 'syncShopifyInventory',
  uploadId: 'uploadId',
  productId: 'productId',
  productVariantId: 'productVariantId',
  approvedAt: 'approvedAt',
  lastSoldAt: 'lastSoldAt',
  isReturnable: 'isReturnable',
  weight: 'weight',
  weightUnit: 'weightUnit',
  approvalMetadata: 'approvalMetadata'
};

exports.Prisma.DraftListingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  state: 'state',
  sharetribeListingId: 'sharetribeListingId',
  title: 'title',
  price: 'price',
  currency: 'currency',
  findItemMethod: 'findItemMethod',
  itemBrand: 'itemBrand',
  itemType: 'itemType',
  categories: 'categories',
  privateSellerNotes: 'privateSellerNotes',
  condition: 'condition',
  notes: 'notes',
  originalPrice: 'originalPrice',
  productHtml: 'productHtml',
  quirks: 'quirks',
  selectedVariantOptions: 'selectedVariantOptions',
  tags: 'tags',
  sellerPhotos: 'sellerPhotos',
  stockPhotoUrls: 'stockPhotoUrls',
  priceDropConfigJson: 'priceDropConfigJson',
  listingFlowMetadata: 'listingFlowMetadata',
  shopId: 'shopId',
  sellerId: 'sellerId',
  publishedListingId: 'publishedListingId',
  productId: 'productId',
  productVariantId: 'productVariantId',
  sourceListingId: 'sourceListingId'
};

exports.Prisma.ListingMediaScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  listingId: 'listingId',
  mediaId: 'mediaId',
  orderIndex: 'orderIndex',
  type: 'type',
  isRelisted: 'isRelisted',
  isBackgroundRemoved: 'isBackgroundRemoved',
  originalUrl: 'originalUrl',
  width: 'width',
  height: 'height'
};

exports.Prisma.ProductMediaScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  productId: 'productId',
  productVariantId: 'productVariantId',
  mediaId: 'mediaId',
  orderIndex: 'orderIndex'
};

exports.Prisma.MediaScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  source: 'source',
  originalUrl: 'originalUrl',
  cdnUrl: 'cdnUrl',
  mimeType: 'mimeType',
  metadata: 'metadata'
};

exports.Prisma.PartnerDataScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  apiMetadata: 'apiMetadata',
  externalIdentifier: 'externalIdentifier',
  listingId: 'listingId',
  partnerId: 'partnerId'
};

exports.Prisma.ListingAuditLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  type: 'type',
  email: 'email',
  actor: 'actor',
  actorIdentifier: 'actorIdentifier',
  actorDetails: 'actorDetails',
  updatedAt: 'updatedAt',
  listingId: 'listingId',
  updateData: 'updateData'
};

exports.Prisma.ListingPriceHistoryScalarFieldEnum = {
  id: 'id',
  listingId: 'listingId',
  oldPrice: 'oldPrice',
  newPrice: 'newPrice',
  updatedAt: 'updatedAt'
};

exports.Prisma.UploadScalarFieldEnum = {
  id: 'id',
  type: 'type',
  uploadId: 'uploadId'
};

exports.Prisma.FavoritedItemScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  listingId: 'listingId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CartItemScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  listingId: 'listingId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  quantity: 'quantity'
};

exports.Prisma.AuditLogScalarFieldEnum = {
  id: 'id',
  timestamp: 'timestamp',
  schemaName: 'schemaName',
  tableName: 'tableName',
  operation: 'operation',
  userName: 'userName',
  newValues: 'newValues',
  oldValues: 'oldValues',
  objectId: 'objectId'
};

exports.Prisma.CreditCodeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  amount: 'amount',
  type: 'type',
  provider: 'provider',
  code: 'code',
  bundleId: 'bundleId',
  providerId: 'providerId',
  inactiveCodes: 'inactiveCodes',
  aggregateRedeemedOrderValue: 'aggregateRedeemedOrderValue',
  redeemedExternalOrderIds: 'redeemedExternalOrderIds',
  redemptionStatus: 'redemptionStatus',
  currency: 'currency',
  expireAt: 'expireAt'
};

exports.Prisma.ShopScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  brandName: 'brandName',
  canonicalRootUrl: 'canonicalRootUrl',
  treetId: 'treetId',
  hostname: 'hostname',
  defaultCurrency: 'defaultCurrency',
  primaryLocale: 'primaryLocale',
  alloyUserId: 'alloyUserId',
  brandTier: 'brandTier',
  churnedAt: 'churnedAt'
};

exports.Prisma.ShopIntegrationConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  authoredByUserId: 'authoredByUserId',
  shopId: 'shopId',
  integrationType: 'integrationType',
  isActive: 'isActive',
  configuration: 'configuration'
};

exports.Prisma.SavedSearchScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  search: 'search',
  shopId: 'shopId',
  subscribeSource: 'subscribeSource',
  cadence: 'cadence',
  type: 'type',
  status: 'status',
  resolvedVariantIds: 'resolvedVariantIds'
};

exports.Prisma.DisbursementScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  shopId: 'shopId',
  startDate: 'startDate',
  endDate: 'endDate',
  status: 'status',
  currency: 'currency',
  bundleIds: 'bundleIds',
  liquidationLineItemIds: 'liquidationLineItemIds',
  disbursedToEmail: 'disbursedToEmail',
  returnShippingCostTotal: 'returnShippingCostTotal',
  reimbursedShippingCostTotal: 'reimbursedShippingCostTotal',
  reimbursedSellerShippingCostTotal: 'reimbursedSellerShippingCostTotal',
  reimbursedLiquidationShippingCostTotal: 'reimbursedLiquidationShippingCostTotal',
  passThroughBrandDirectTaxTotal: 'passThroughBrandDirectTaxTotal',
  brandCoveredShippingCostTotal: 'brandCoveredShippingCostTotal',
  additionalLineItems: 'additionalLineItems',
  additionalCostsTotal: 'additionalCostsTotal',
  brandCoveredDiscountsTotal: 'brandCoveredDiscountsTotal',
  brandDirectSalesGMVTotal: 'brandDirectSalesGMVTotal',
  brandDirectSalesPayoutTotal: 'brandDirectSalesPayoutTotal',
  ccProcessingTotal: 'ccProcessingTotal',
  customerPaidTotal: 'customerPaidTotal',
  discountsTotal: 'discountsTotal',
  earningsTotal: 'earningsTotal',
  finalDepositTotal: 'finalDepositTotal',
  grossMarginTotal: 'grossMarginTotal',
  grossMerchandiseValueTotal: 'grossMerchandiseValueTotal',
  grossMerchandiseValueTotalAcrossAllChannels: 'grossMerchandiseValueTotalAcrossAllChannels',
  peerCashSalesGMVTotal: 'peerCashSalesGMVTotal',
  peerCreditSalesGMVTotal: 'peerCreditSalesGMVTotal',
  peerSellerPayoutTotal: 'peerSellerPayoutTotal',
  previouslyDepositedTotal: 'previouslyDepositedTotal',
  reimbursementsTotal: 'reimbursementsTotal',
  relistedTradeInSalesGMVTotal: 'relistedTradeInSalesGMVTotal',
  relistedTradeInSalesPayoutTotal: 'relistedTradeInSalesPayoutTotal',
  salesCostTotal: 'salesCostTotal',
  shippingTotal: 'shippingTotal',
  liquidationShippingTotal: 'liquidationShippingTotal',
  liquidationCustomerPaidTotal: 'liquidationCustomerPaidTotal',
  treetTakeTotal: 'treetTakeTotal',
  returnInsuranceTotal: 'returnInsuranceTotal',
  eBayLiquidationLineItemGMVTotal: 'eBayLiquidationLineItemGMVTotal',
  accountType: 'accountType',
  taxTotal: 'taxTotal',
  type: 'type'
};

exports.Prisma.ClientApiKeyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  contactEmail: 'contactEmail',
  clientId: 'clientId',
  apiKey: 'apiKey',
  accessibleEndpoints: 'accessibleEndpoints',
  accessLevel: 'accessLevel',
  shopAccessLevel: 'shopAccessLevel',
  shopId: 'shopId'
};

exports.Prisma.EmailHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  emailName: 'emailName',
  emailAddress: 'emailAddress',
  shopId: 'shopId',
  emailData: 'emailData',
  uniqueEmailId: 'uniqueEmailId'
};

exports.Prisma.JobHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  queueName: 'queueName',
  jobName: 'jobName',
  status: 'status',
  data: 'data',
  error: 'error',
  startedAt: 'startedAt'
};

exports.Prisma.ExternalShopScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  shopId: 'shopId',
  externalCommercePlatform: 'externalCommercePlatform'
};

exports.Prisma.ExternalOrderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  externalId: 'externalId',
  externalCreatedAt: 'externalCreatedAt',
  totalPrice: 'totalPrice',
  currency: 'currency',
  externalCustomerId: 'externalCustomerId',
  externalShopId: 'externalShopId',
  rawData: 'rawData'
};

exports.Prisma.ExternalCustomerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  externalId: 'externalId',
  externalCreatedAt: 'externalCreatedAt',
  externalShopId: 'externalShopId',
  userId: 'userId',
  rawData: 'rawData'
};

exports.Prisma.PlatformKeysScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  keyName: 'keyName',
  value: 'value'
};

exports.Prisma.PriceDropConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  listingId: 'listingId',
  minPrice: 'minPrice',
  anchorPrice: 'anchorPrice',
  percentageDrop: 'percentageDrop',
  nextScheduledDrop: 'nextScheduledDrop',
  daysBetweenPriceDrops: 'daysBetweenPriceDrops',
  isActive: 'isActive'
};

exports.Prisma.PriceDropHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  listingId: 'listingId',
  startingPrice: 'startingPrice',
  droppedAmount: 'droppedAmount',
  newPrice: 'newPrice',
  configSnapshot: 'configSnapshot'
};

exports.Prisma.ListingFeedbackScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  category: 'category',
  note: 'note',
  listingId: 'listingId',
  feedbackAuthorId: 'feedbackAuthorId',
  sharetribeListingId: 'sharetribeListingId',
  status: 'status',
  excludedAt: 'excludedAt',
  moderationMetadata: 'moderationMetadata'
};

exports.Prisma.GradingDetailsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  gradingTier: 'gradingTier',
  note: 'note',
  imagesData: 'imagesData',
  graderId: 'graderId',
  bundleItemId: 'bundleItemId'
};

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  title: 'title',
  shopId: 'shopId',
  status: 'status',
  description: 'description',
  productType: 'productType',
  vendor: 'vendor',
  tags: 'tags',
  mediaCount: 'mediaCount',
  externalProductId: 'externalProductId',
  metadata: 'metadata'
};

exports.Prisma.ProductVariantScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  shopId: 'shopId',
  selectedVariantOptions: 'selectedVariantOptions',
  price: 'price',
  compareAtPrice: 'compareAtPrice',
  currency: 'currency',
  sku: 'sku',
  weight: 'weight',
  weightUnit: 'weightUnit',
  barcode: 'barcode',
  mediaCount: 'mediaCount',
  externalProductVariantId: 'externalProductVariantId',
  productId: 'productId',
  metadata: 'metadata'
};

exports.Prisma.ExternalProductScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  externalId: 'externalId',
  externalShopId: 'externalShopId',
  status: 'status',
  rawData: 'rawData',
  isDeleted: 'isDeleted'
};

exports.Prisma.ExternalProductVariantScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  externalShopId: 'externalShopId',
  status: 'status',
  externalId: 'externalId',
  externalSku: 'externalSku',
  rawData: 'rawData',
  externalProductId: 'externalProductId',
  isDeleted: 'isDeleted'
};

exports.Prisma.AlloyWorkflowHistoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  workflowId: 'workflowId',
  executionId: 'executionId',
  alloyUserId: 'alloyUserId',
  shopId: 'shopId',
  uniqueRunId: 'uniqueRunId',
  data: 'data'
};

exports.Prisma.EmailTranslationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  emailIdentifier: 'emailIdentifier',
  locale: 'locale',
  body: 'body',
  subject: 'subject'
};

exports.Prisma.InventoryAuditLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  listingId: 'listingId',
  oldInventoryQuantity: 'oldInventoryQuantity',
  newInventoryQuantity: 'newInventoryQuantity',
  inventoryAdjustment: 'inventoryAdjustment'
};

exports.Prisma.BrandHealthLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  shopId: 'shopId',
  inventoryScore: 'inventoryScore',
  promotionScore: 'promotionScore',
  overallScore: 'overallScore',
  inventoryScoreGrade: 'inventoryScoreGrade',
  promotionScoreGrade: 'promotionScoreGrade',
  overallScoreGrade: 'overallScoreGrade',
  actionsTaken: 'actionsTaken',
  businessMetrics: 'businessMetrics'
};

exports.Prisma.BrandHealthOverridesScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  shopId: 'shopId',
  businessMetricsOverrides: 'businessMetricsOverrides',
  actionsTakenOverrides: 'actionsTakenOverrides'
};

exports.Prisma.LiquidationListingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  uploadId: 'uploadId',
  listingId: 'listingId',
  shopId: 'shopId',
  price: 'price',
  currency: 'currency',
  liquidationPartner: 'liquidationPartner',
  liquidationPartnerListingId: 'liquidationPartnerListingId',
  metadata: 'metadata',
  liquidationShopId: 'liquidationShopId'
};

exports.Prisma.LiquidationShopScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  liquidationPartner: 'liquidationPartner',
  isActive: 'isActive',
  shopId: 'shopId',
  metadata: 'metadata'
};

exports.Prisma.LiquidationOrderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  liquidationPartner: 'liquidationPartner',
  liquidationPartnerOrderId: 'liquidationPartnerOrderId',
  liquidationPartnerCustomerId: 'liquidationPartnerCustomerId',
  subtotal: 'subtotal',
  currency: 'currency',
  status: 'status',
  taxPrice: 'taxPrice',
  shippingPrice: 'shippingPrice',
  totalPrice: 'totalPrice',
  shipToAddress: 'shipToAddress',
  totalRefundPrice: 'totalRefundPrice',
  metadata: 'metadata'
};

exports.Prisma.LiquidationLineItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  liquidationOrderId: 'liquidationOrderId',
  liquidationListingId: 'liquidationListingId',
  liquidationShopId: 'liquidationShopId',
  price: 'price',
  listedPrice: 'listedPrice',
  totalRefundPrice: 'totalRefundPrice',
  payoutInfo: 'payoutInfo',
  currency: 'currency',
  liquidationFulfillmentId: 'liquidationFulfillmentId',
  liquidationPartnerLineItemId: 'liquidationPartnerLineItemId',
  metadata: 'metadata',
  quantity: 'quantity',
  shopifyOrderId: 'shopifyOrderId'
};

exports.Prisma.LiquidationFulfillmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  trackingNumber: 'trackingNumber',
  carrier: 'carrier',
  shipFromAddress: 'shipFromAddress',
  deliveredAt: 'deliveredAt',
  labelUrl: 'labelUrl'
};

exports.Prisma.LiquidationCancellationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  source: 'source',
  reason: 'reason',
  initiatedBy: 'initiatedBy',
  note: 'note',
  completedAt: 'completedAt',
  metadata: 'metadata',
  liquidationLineItemId: 'liquidationLineItemId'
};

exports.Prisma.LiquidationShippingLineItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  price: 'price',
  currency: 'currency',
  totalRefundPrice: 'totalRefundPrice'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.PaymentMethod = exports.$Enums.PaymentMethod = {
  CARD: 'CARD',
  APPLE_PAY: 'APPLE_PAY',
  GOOGLE_PAY: 'GOOGLE_PAY'
};

exports.ItemStatus = exports.$Enums.ItemStatus = {
  CANCELED: 'CANCELED',
  VERIFIED: 'VERIFIED',
  DISPUTE_OPEN: 'DISPUTE_OPEN',
  DISPUTE_ACCEPTED: 'DISPUTE_ACCEPTED',
  DISPUTE_RESOLVED: 'DISPUTE_RESOLVED',
  PAID_OUT: 'PAID_OUT',
  REFUNDED: 'REFUNDED',
  REFUND_INITIATED: 'REFUND_INITIATED',
  RETURN_INITIATED: 'RETURN_INITIATED'
};

exports.BundleStatus = exports.$Enums.BundleStatus = {
  OPEN: 'OPEN',
  SHIPPED: 'SHIPPED',
  DELIVERED: 'DELIVERED',
  CANCELED: 'CANCELED',
  RESOLVED: 'RESOLVED',
  COMPLETED: 'COMPLETED',
  INITIATED: 'INITIATED',
  DISPUTED: 'DISPUTED'
};

exports.BundleType = exports.$Enums.BundleType = {
  TRADE_IN: 'TRADE_IN',
  MARKETPLACE: 'MARKETPLACE'
};

exports.Currency = exports.$Enums.Currency = {
  USD: 'USD',
  CAD: 'CAD',
  AUD: 'AUD',
  GBP: 'GBP',
  EUR: 'EUR'
};

exports.PayoutType = exports.$Enums.PayoutType = {
  CASH: 'CASH',
  CREDIT: 'CREDIT'
};

exports.FulfillmentMethod = exports.$Enums.FulfillmentMethod = {
  TREET: 'TREET',
  SHOPIFY: 'SHOPIFY',
  RETAIL_REWORKS: 'RETAIL_REWORKS',
  PARTNER_SHOPIFY: 'PARTNER_SHOPIFY',
  PEER: 'PEER'
};

exports.ShippingLabelProvider = exports.$Enums.ShippingLabelProvider = {
  TREET: 'TREET',
  SHOPIFY: 'SHOPIFY',
  SUPER_CIRCLE: 'SUPER_CIRCLE',
  SHIPSTATION: 'SHIPSTATION',
  AFTERSHIP: 'AFTERSHIP'
};

exports.FulfillmentStatus = exports.$Enums.FulfillmentStatus = {
  SHIPPED: 'SHIPPED',
  DELIVERED: 'DELIVERED'
};

exports.WeightUnit = exports.$Enums.WeightUnit = {
  OZ: 'OZ',
  G: 'G'
};

exports.LineItemCode = exports.$Enums.LineItemCode = {
  LISTING: 'LISTING',
  SHIPPING: 'SHIPPING',
  DISCOUNT: 'DISCOUNT',
  RETURN_INSURANCE: 'RETURN_INSURANCE',
  TAX: 'TAX'
};

exports.Participant = exports.$Enums.Participant = {
  SELLER: 'SELLER',
  BUYER: 'BUYER',
  BRAND: 'BRAND'
};

exports.DiscountValueType = exports.$Enums.DiscountValueType = {
  PERCENTAGE: 'PERCENTAGE',
  FIXED_AMOUNT: 'FIXED_AMOUNT'
};

exports.DiscountTarget = exports.$Enums.DiscountTarget = {
  ALL: 'ALL'
};

exports.ReturnInsuranceProvider = exports.$Enums.ReturnInsuranceProvider = {
  SEEL: 'SEEL'
};

exports.RefundType = exports.$Enums.RefundType = {
  CANCELLATION: 'CANCELLATION',
  DISPUTE: 'DISPUTE'
};

exports.DisputeStatus = exports.$Enums.DisputeStatus = {
  OPEN: 'OPEN',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED'
};

exports.DisputeReason = exports.$Enums.DisputeReason = {
  INAUTHENTIC: 'INAUTHENTIC',
  NOT_AS_DESCRIBED: 'NOT_AS_DESCRIBED',
  WRONG_ITEM: 'WRONG_ITEM',
  MISSING: 'MISSING',
  OTHER: 'OTHER',
  DAMAGED_BUT_ACCEPTABLE: 'DAMAGED_BUT_ACCEPTABLE',
  INAUTHENTIC_OR_EXCESSIVE_DAMAGE: 'INAUTHENTIC_OR_EXCESSIVE_DAMAGE',
  CONDITION_ADJUSTMENT: 'CONDITION_ADJUSTMENT',
  NOT_ACCEPTABLE: 'NOT_ACCEPTABLE',
  NONE: 'NONE',
  DAMAGED_OR_LOST: 'DAMAGED_OR_LOST',
  DID_NOT_FIT: 'DID_NOT_FIT',
  DID_NOT_LIKE: 'DID_NOT_LIKE',
  FOUND_ALTERNATIVE: 'FOUND_ALTERNATIVE'
};

exports.CancelReason = exports.$Enums.CancelReason = {
  SOLD_ELSEWHERE: 'SOLD_ELSEWHERE',
  KEEP_ITEM: 'KEEP_ITEM',
  SHIPPING_EXPIRED: 'SHIPPING_EXPIRED',
  CANCELED_FROM_SHOPIFY: 'CANCELED_FROM_SHOPIFY',
  OTHER: 'OTHER'
};

exports.Actor = exports.$Enums.Actor = {
  BUYER: 'BUYER',
  SELLER: 'SELLER',
  ADMIN: 'ADMIN'
};

exports.CountryCode = exports.$Enums.CountryCode = {
  US: 'US',
  AU: 'AU',
  CA: 'CA',
  GB: 'GB',
  FR: 'FR',
  DE: 'DE',
  IT: 'IT',
  ES: 'ES',
  NL: 'NL'
};

exports.Locale = exports.$Enums.Locale = {
  EN_US: 'EN_US',
  EN_GB: 'EN_GB',
  EN_CA: 'EN_CA',
  EN_AU: 'EN_AU',
  FR_CA: 'FR_CA',
  FR_FR: 'FR_FR',
  DE_DE: 'DE_DE',
  IT_IT: 'IT_IT',
  ES_ES: 'ES_ES',
  EN_NL: 'EN_NL',
  NL_NL: 'NL_NL'
};

exports.ListingState = exports.$Enums.ListingState = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  PENDING_BRAND_APPROVAL: 'PENDING_BRAND_APPROVAL',
  DELETED: 'DELETED'
};

exports.FindItemMethod = exports.$Enums.FindItemMethod = {
  SEARCH: 'SEARCH',
  EMAIL_ACCOUNT: 'EMAIL_ACCOUNT',
  ORDER_NUMBER: 'ORDER_NUMBER',
  CANNOT_FIND: 'CANNOT_FIND',
  ALL_PRODUCTS: 'ALL_PRODUCTS',
  UPLOAD: 'UPLOAD',
  API_UPLOAD: 'API_UPLOAD',
  MANUAL: 'MANUAL',
  LIST_ANY_BRAND: 'LIST_ANY_BRAND',
  RELIST_AS_DUPLICATE: 'RELIST_AS_DUPLICATE',
  RELIST_FROM_TREET: 'RELIST_FROM_TREET',
  TRADE_IN_UPLOAD: 'TRADE_IN_UPLOAD',
  QUERY_PARAM: 'QUERY_PARAM',
  UNKNOWN: 'UNKNOWN'
};

exports.ListingItemType = exports.$Enums.ListingItemType = {
  MARKETPLACE: 'MARKETPLACE',
  TRADE_IN: 'TRADE_IN'
};

exports.ListingCondition = exports.$Enums.ListingCondition = {
  NEW_WITH_TAGS: 'NEW_WITH_TAGS',
  NEW_WITHOUT_TAGS: 'NEW_WITHOUT_TAGS',
  EXCELLENT: 'EXCELLENT',
  GOOD: 'GOOD',
  MINOR_DEFECT: 'MINOR_DEFECT'
};

exports.DraftListingState = exports.$Enums.DraftListingState = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  DELETED: 'DELETED'
};

exports.MediaType = exports.$Enums.MediaType = {
  SELLER: 'SELLER',
  STOCK: 'STOCK'
};

exports.MediaSource = exports.$Enums.MediaSource = {
  UPLOADCARE: 'UPLOADCARE',
  BRAND: 'BRAND'
};

exports.ListingUpdateType = exports.$Enums.ListingUpdateType = {
  APPROVE: 'APPROVE',
  BRAND_APPROVE: 'BRAND_APPROVE',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  CLOSE: 'CLOSE',
  OPEN: 'OPEN',
  DELETE: 'DELETE',
  SET_INVENTORY: 'SET_INVENTORY',
  ADJUST_INVENTORY: 'ADJUST_INVENTORY'
};

exports.ActorType = exports.$Enums.ActorType = {
  SYSTEM: 'SYSTEM',
  USER: 'USER',
  API: 'API'
};

exports.UploadType = exports.$Enums.UploadType = {
  DUPLICATE: 'DUPLICATE',
  TRANSFER: 'TRANSFER',
  CROSS_POST: 'CROSS_POST',
  MANUAL: 'MANUAL'
};

exports.CreditCodeType = exports.$Enums.CreditCodeType = {
  DISCOUNT_CODE: 'DISCOUNT_CODE',
  GIFT_CARD: 'GIFT_CARD',
  LOYALTY_POINTS: 'LOYALTY_POINTS',
  PACT_CASH: 'PACT_CASH'
};

exports.CreditCodeProvider = exports.$Enums.CreditCodeProvider = {
  SHOPIFY: 'SHOPIFY',
  DOPPLE: 'DOPPLE',
  RISE_AI: 'RISE_AI',
  BIGCOMMERCE: 'BIGCOMMERCE',
  YOTPO: 'YOTPO',
  TEAMWORK_COMMERCE: 'TEAMWORK_COMMERCE',
  MAGENTO: 'MAGENTO',
  GIVEX: 'GIVEX',
  PACT: 'PACT'
};

exports.CreditCodeRedemptionStatus = exports.$Enums.CreditCodeRedemptionStatus = {
  REDEEMED: 'REDEEMED',
  PARTIALLY_REDEEMED: 'PARTIALLY_REDEEMED',
  NOT_REDEEMED: 'NOT_REDEEMED',
  DUPLICATE: 'DUPLICATE'
};

exports.ShopIntegrationType = exports.$Enums.ShopIntegrationType = {
  LOYALTYLION_REWARDS: 'LOYALTYLION_REWARDS',
  SHOPIFY_CUSTOMER_SEGMENTATION: 'SHOPIFY_CUSTOMER_SEGMENTATION',
  YOTPO_REWARDS: 'YOTPO_REWARDS',
  LOOP_RETURNS: 'LOOP_RETURNS',
  HAPPYRETURNS_RETURNS: 'HAPPYRETURNS_RETURNS',
  FILLOGIC_RETURNS: 'FILLOGIC_RETURNS',
  RISEAI_CREDIT: 'RISEAI_CREDIT',
  GIVEX_CREDIT: 'GIVEX_CREDIT',
  KLAVIYO_CUSTOMER_SEGMENTATION: 'KLAVIYO_CUSTOMER_SEGMENTATION',
  KLAVIYO_EMAIL_CUSTOMIZATION: 'KLAVIYO_EMAIL_CUSTOMIZATION'
};

exports.EmailSubscribeSource = exports.$Enums.EmailSubscribeSource = {
  FOOTER: 'FOOTER',
  SEARCH_RESULTS_BANNER: 'SEARCH_RESULTS_BANNER',
  CHECKOUT: 'CHECKOUT',
  TREET_SHOP_FOOTER: 'TREET_SHOP_FOOTER',
  NOTIFICATION_SETTINGS: 'NOTIFICATION_SETTINGS',
  LANDING_PAGE_MODAL: 'LANDING_PAGE_MODAL',
  PROFILE_DROPDOWN: 'PROFILE_DROPDOWN',
  SEARCH_RESULTS_BANNER_ISO: 'SEARCH_RESULTS_BANNER_ISO',
  PROFILE_DROPDOWN_ISO: 'PROFILE_DROPDOWN_ISO',
  LISTING_PAGE_ISO: 'LISTING_PAGE_ISO'
};

exports.Cadence = exports.$Enums.Cadence = {
  WEEKLY: 'WEEKLY',
  NEVER: 'NEVER',
  IMMEDIATELY: 'IMMEDIATELY'
};

exports.SavedSearchType = exports.$Enums.SavedSearchType = {
  GENERAL: 'GENERAL',
  IN_SEARCH_OF: 'IN_SEARCH_OF'
};

exports.SavedSearchStatus = exports.$Enums.SavedSearchStatus = {
  ACTIVE: 'ACTIVE',
  IN_SEARCH_OF_LISTING_REQUEST_SENT: 'IN_SEARCH_OF_LISTING_REQUEST_SENT'
};

exports.DisbursementStatus = exports.$Enums.DisbursementStatus = {
  INITIATED: 'INITIATED',
  AWAITING_BANK_INFO: 'AWAITING_BANK_INFO',
  FAILURE: 'FAILURE',
  PAID_OUT: 'PAID_OUT'
};

exports.DisbursementAccountType = exports.$Enums.DisbursementAccountType = {
  BRAND: 'BRAND',
  PARTNER: 'PARTNER'
};

exports.DisbursementType = exports.$Enums.DisbursementType = {
  DISBURSEMENT: 'DISBURSEMENT',
  REPORT: 'REPORT'
};

exports.AccessLevel = exports.$Enums.AccessLevel = {
  FULL_ACCESS: 'FULL_ACCESS',
  PARTIAL_ACCESS: 'PARTIAL_ACCESS'
};

exports.JobStatus = exports.$Enums.JobStatus = {
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED'
};

exports.ExternalCommercePlatform = exports.$Enums.ExternalCommercePlatform = {
  SHOPIFY: 'SHOPIFY',
  MAGENTO: 'MAGENTO',
  BIGCOMMERCE: 'BIGCOMMERCE',
  CUSTOM: 'CUSTOM'
};

exports.ListingFeedbackStatus = exports.$Enums.ListingFeedbackStatus = {
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  SELLER_NOTIFIED: 'SELLER_NOTIFIED',
  EXCLUDED: 'EXCLUDED',
  CLOSED_WITHOUT_SENDING: 'CLOSED_WITHOUT_SENDING'
};

exports.GradingTier = exports.$Enums.GradingTier = {
  NEW_WITH_TAGS: 'NEW_WITH_TAGS',
  EXCELLENT: 'EXCELLENT',
  GOOD: 'GOOD',
  RECYCLABLE: 'RECYCLABLE',
  DAMAGED: 'DAMAGED',
  MISSING: 'MISSING',
  WRONG_ITEM: 'WRONG_ITEM'
};

exports.ProductType = exports.$Enums.ProductType = {
  EXTERNAL: 'EXTERNAL',
  CUSTOM: 'CUSTOM'
};

exports.ProductStatus = exports.$Enums.ProductStatus = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
  DRAFT: 'DRAFT',
  EXCLUDED: 'EXCLUDED',
  UNKNOWN: 'UNKNOWN',
  DELETED: 'DELETED'
};

exports.ProductVariantType = exports.$Enums.ProductVariantType = {
  EXTERNAL: 'EXTERNAL',
  CUSTOM: 'CUSTOM'
};

exports.ExternalRecordStatus = exports.$Enums.ExternalRecordStatus = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED'
};

exports.BrandHealthGrade = exports.$Enums.BrandHealthGrade = {
  S: 'S',
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  F: 'F',
  UNKNOWN: 'UNKNOWN'
};

exports.LiquidationListingStatus = exports.$Enums.LiquidationListingStatus = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  DELETED: 'DELETED'
};

exports.LiquidationPartner = exports.$Enums.LiquidationPartner = {
  EBAY: 'EBAY'
};

exports.LiquidationOrderStatus = exports.$Enums.LiquidationOrderStatus = {
  OPEN: 'OPEN',
  SHIPPED: 'SHIPPED',
  DELIVERED: 'DELIVERED',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED'
};

exports.LiquidationFulfillmentStatus = exports.$Enums.LiquidationFulfillmentStatus = {
  OPEN: 'OPEN',
  TRACKING_RECEIVED: 'TRACKING_RECEIVED',
  SHIPPED: 'SHIPPED',
  DELIVERED: 'DELIVERED'
};

exports.LiquidationCancellationStatus = exports.$Enums.LiquidationCancellationStatus = {
  COMPLETED: 'COMPLETED',
  REQUESTED: 'REQUESTED',
  REJECTED: 'REJECTED'
};

exports.LiquidationCancellationSource = exports.$Enums.LiquidationCancellationSource = {
  BUYER_AUTO_INITIATED: 'BUYER_AUTO_INITIATED',
  BUYER_MANUAL_INITIATED: 'BUYER_MANUAL_INITIATED',
  CANCELED_FROM_SHOPIFY: 'CANCELED_FROM_SHOPIFY',
  OTHER: 'OTHER'
};

exports.LiquidationCancellationReason = exports.$Enums.LiquidationCancellationReason = {
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  BUYER_MISTAKE: 'BUYER_MISTAKE',
  CANNOT_SHIP: 'CANNOT_SHIP',
  UNKNOWN: 'UNKNOWN',
  OTHER: 'OTHER'
};

exports.Prisma.ModelName = {
  Order: 'Order',
  Address: 'Address',
  BundleItem: 'BundleItem',
  Bundle: 'Bundle',
  BundleNote: 'BundleNote',
  Fulfillment: 'Fulfillment',
  LineItem: 'LineItem',
  ListingLineItem: 'ListingLineItem',
  ShippingLineItem: 'ShippingLineItem',
  TaxLineItem: 'TaxLineItem',
  DiscountLineItem: 'DiscountLineItem',
  ReturnInsuranceLineItem: 'ReturnInsuranceLineItem',
  Refund: 'Refund',
  Dispute: 'Dispute',
  DisputeResolution: 'DisputeResolution',
  Payout: 'Payout',
  Cancellation: 'Cancellation',
  User: 'User',
  Listing: 'Listing',
  DraftListing: 'DraftListing',
  ListingMedia: 'ListingMedia',
  ProductMedia: 'ProductMedia',
  Media: 'Media',
  PartnerData: 'PartnerData',
  ListingAuditLog: 'ListingAuditLog',
  ListingPriceHistory: 'ListingPriceHistory',
  Upload: 'Upload',
  FavoritedItem: 'FavoritedItem',
  CartItem: 'CartItem',
  AuditLog: 'AuditLog',
  CreditCode: 'CreditCode',
  Shop: 'Shop',
  ShopIntegrationConfig: 'ShopIntegrationConfig',
  SavedSearch: 'SavedSearch',
  Disbursement: 'Disbursement',
  ClientApiKey: 'ClientApiKey',
  EmailHistory: 'EmailHistory',
  JobHistory: 'JobHistory',
  ExternalShop: 'ExternalShop',
  ExternalOrder: 'ExternalOrder',
  ExternalCustomer: 'ExternalCustomer',
  PlatformKeys: 'PlatformKeys',
  PriceDropConfig: 'PriceDropConfig',
  PriceDropHistory: 'PriceDropHistory',
  ListingFeedback: 'ListingFeedback',
  GradingDetails: 'GradingDetails',
  Product: 'Product',
  ProductVariant: 'ProductVariant',
  ExternalProduct: 'ExternalProduct',
  ExternalProductVariant: 'ExternalProductVariant',
  AlloyWorkflowHistory: 'AlloyWorkflowHistory',
  EmailTranslation: 'EmailTranslation',
  InventoryAuditLog: 'InventoryAuditLog',
  BrandHealthLog: 'BrandHealthLog',
  BrandHealthOverrides: 'BrandHealthOverrides',
  LiquidationListing: 'LiquidationListing',
  LiquidationShop: 'LiquidationShop',
  LiquidationOrder: 'LiquidationOrder',
  LiquidationLineItem: 'LiquidationLineItem',
  LiquidationFulfillment: 'LiquidationFulfillment',
  LiquidationCancellation: 'LiquidationCancellation',
  LiquidationShippingLineItem: 'LiquidationShippingLineItem'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
